/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSFTPRequest } from '../models/CreateSFTPRequest';
import type { PGPKeyPair } from '../models/PGPKeyPair';
import type { SFTPIntegration } from '../models/SFTPIntegration';
import type { UpdateSFTPRequest } from '../models/UpdateSFTPRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SftpService {

    /**
     * Return data sources for SFTP integration
     * @returns any Success
     * @throws ApiError
     */
    public static getSftpIntegration(): CancelablePromise<{
        integration?: (SFTPIntegration | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sftp',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Creates SFTP integration
     * @returns SFTPIntegration Success
     * @throws ApiError
     */
    public static createSftpIntegration({
        requestBody,
    }: {
        requestBody: CreateSFTPRequest,
    }): CancelablePromise<SFTPIntegration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sftp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update SFTP integration
     * @returns SFTPIntegration Success
     * @throws ApiError
     */
    public static updateSftpIntegration({
        id,
        requestBody,
    }: {
        /**
         * SFTP integration id
         */
        id: number,
        requestBody: UpdateSFTPRequest,
    }): CancelablePromise<SFTPIntegration> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sftp/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete SFTP integration
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSftpIntegration({
        id,
    }: {
        /**
         * SFTP Integration id
         */
        id: number,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/sftp/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Parse public key
     * @returns string Success
     * @throws ApiError
     */
    public static parsePublicKey({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sftp/publicKey',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Generate PGP key pair
     * @returns PGPKeyPair Success
     * @throws ApiError
     */
    public static generatePgpKeyPair({
        expDate,
    }: {
        /**
         * Expiration Date
         */
        expDate?: string,
    }): CancelablePromise<PGPKeyPair> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sftp/pgp',
            query: {
                'expDate': expDate,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Parse PGP key
     * @returns PGPKeyPair Success
     * @throws ApiError
     */
    public static parsePgpKey({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<PGPKeyPair> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sftp/pgp',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
